import React from "react";

const FaqShimmerCard = () => {
  return (
    <div className="w-full p-4 rounded-xl border bg-white shadow-sm flex flex-col gap-3">
      {/* Title */}
      <div className="h-5 w-3/4 bg-gray-200 rounded relative overflow-hidden">
        <div
          className="absolute inset-0 bg-gradient-to-r 
          from-gray-200 via-gray-300 to-gray-200 
          bg-[length:600px_100%] animate-shimmer"
        ></div>
      </div>

      <div className="border-b my-1"></div>

      {/* Answer lines */}
      <div className="flex flex-col gap-2">
        <div className="h-4 w-full bg-gray-200 rounded relative overflow-hidden">
          <div
            className="absolute inset-0 bg-gradient-to-r 
            from-gray-200 via-gray-300 to-gray-200 
            bg-[length:600px_100%] animate-shimmer"
          ></div>
        </div>

        <div className="h-4 w-5/6 bg-gray-200 rounded relative overflow-hidden">
          <div
            className="absolute inset-0 bg-gradient-to-r 
            from-gray-200 via-gray-300 to-gray-200 
            bg-[length:600px_100%] animate-shimmer"
          ></div>
        </div>

        <div className="h-4 w-4/6 bg-gray-200 rounded relative overflow-hidden">
          <div
            className="absolute inset-0 bg-gradient-to-r 
            from-gray-200 via-gray-300 to-gray-200 
            bg-[length:600px_100%] animate-shimmer"
          ></div>
        </div>
      </div>

      <div className="border-b my-2"></div>

      {/* Footer status row */}
      <div className="flex justify-between items-center mt-1">
        <div className="h-4 w-16 bg-gray-200 rounded relative overflow-hidden">
          <div
            className="absolute inset-0 bg-gradient-to-r 
            from-gray-200 via-gray-300 to-gray-200 
            bg-[length:600px_100%] animate-shimmer"
          ></div>
        </div>

        <div className="h-5 w-10 bg-gray-200 rounded-full relative overflow-hidden">
          <div
            className="absolute inset-0 bg-gradient-to-r 
            from-gray-200 via-gray-300 to-gray-200 
            bg-[length:600px_100%] animate-shimmer"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default FaqShimmerCard;
